import { render, staticRenderFns } from "./ClientBase.vue?vue&type=template&id=571b762d&scoped=true&"
import script from "./ClientBase.vue?vue&type=script&lang=js&"
export * from "./ClientBase.vue?vue&type=script&lang=js&"
import style0 from "./ClientBase.vue?vue&type=style&index=0&id=571b762d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571b762d",
  null
  
)

export default component.exports